/* eslint-disable */

export enum LoadingStatus {
	Idle = -1,
	Loading = 0,
	Completed = 1,
	Fetching = 2,
	Error = 3,
	
}
